"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @mixin sizeMixin */
/**
 * Sets the height of a component without explicity setting the height css attribute.
 * It does this by adusting padding based on the border and line-height to make sure the sum of the
 * three equals the desired size. This allows component to scale with changes to the `fontType`
 * line-height while maintaining proper padding.
 *
 * @method
 * @param {object} opts
 * @param {number} opts.borderWidth - The border width of the component.
 * @param {string} opts.fontType - The default font type of the component.
 * @param {string|number} [opts.size='md'] - The preferred size of the component. This leverages
 *     size tokens when a string, or you can set it number value directly.
 */
var sizeMixin = function sizeMixin(_ref) {
  var borderWidth = _ref.borderWidth,
    defaultFontType = _ref.fontType,
    _ref$size = _ref.size,
    defaultSize = _ref$size === void 0 ? 'md' : _ref$size;
  return function (props) {
    var givenFontType = props.fontType,
      givenSize = props.size;
    return (0, _styledToken.default)({
      lineHeights: 'lineHeights',
      HEIGHT: 'sizes.heights'
    }, function (_ref2) {
      var lineHeights = _ref2.lineHeights,
        HEIGHT = _ref2.HEIGHT;
      if (!lineHeights || !HEIGHT) {
        return '';
      }

      // Calculate the padding based off the default fontType
      var defaultHeight;
      if (typeof defaultSize === 'number') {
        defaultHeight = defaultSize;
      } else {
        defaultHeight = HEIGHT[givenSize || defaultSize];
      }
      var defaultLineHeight = lineHeights[defaultFontType];
      var padding = defaultHeight - defaultLineHeight - borderWidth;

      // Adjust line-height if necessary
      var lineHeight = defaultLineHeight;
      if (typeof givenFontType !== 'undefined') {
        lineHeight = lineHeights[givenFontType];
      }

      // Half pixel paddings can cause slight rendering issues (FDS-65)
      if (padding % 2 > 0) {
        padding -= 1;
        lineHeight += 1;
      }
      return "\n                padding-top: " + padding / 2 + "px;\n                padding-bottom: " + padding / 2 + "px;\n                line-height: " + lineHeight + "px;\n\n                /* allow content to overflow */\n                height: auto;\n            ";
    })(props);
  };
};
exports.sizeMixin = sizeMixin;